<template>
  <div>
    <b-col cols="12">
      <b-row>
        <documents ref="documentList" 
                   docType="vehicle" 
                  :vehicleId="selectedVehicle._id" 
                  :docList="vehicleDocuments"
                  :docErrors="errorDoc"
                  @saveDocCallback="saveDocument" 
                  @updateCallback="updateDocument"/>
        <b-col cols="12" align="right">
          <b-button size="sm" variant="secondary" @click="closeModal">Close</b-button>
        </b-col>
      </b-row>
    </b-col>
  </div>
</template>

<script>
import shebahApi from "@/services/shebah/index";
import documents from "@/components/documents.vue";
import moment from "moment";
export default {
  name: "vehiclesDocs",
  components: {
    documents
  },
  props: {
    selectedVehicle: Object,
    driverId:String
  },
  computed: {},
  data() {
    return {
      vehicleDocuments:{},
      errorDoc:{}
    };
  },
  watch: {},
  async created() {
      this.getdocuments();
  },
  methods: {
     async getdocuments(){
        this.vehicleDocuments=await shebahApi.api.drivers.vehicles.getVehicleDocuments(
              this.driverId,
              this.selectedVehicle._id);
     },
     async saveDocument(document){
       try{
          let savedDoc=await shebahApi.api.drivers.vehicles.saveVehicleDocuments(this.driverId,
              document.key,
              document.data,
              this.selectedVehicle._id
            );
            this.errorDoc=null;
            await this.getdocuments();
            this.$emit("updatedCount", {_id:this.driverId,uploadCount:savedDoc.driverDocUploadCount});
       }catch(e){
          if (e.response) {
          if (
            typeof e.response.data.error !== "undefined" &&
            typeof e.response.data.error.collection !== "undefined"
          ) {
            this.errorDoc = e.response.data.error.collection;
          }
        }
       }
    },
    closeModal(){
      this.$emit("closeCallback",{});
    },
    async updateDocument(document){
       try{
      await shebahApi.api.drivers.vehicles.updateVehicleDocument(
              this.driverId,
              document.key,
              document.data,
              this.selectedVehicle._id
            );
            this.errorDoc=null;
            this.getdocuments();
            this.getVehicleDocList(this.selectedVehicleId);
       }catch(e){
         if (e.response) {
          if (
            typeof e.response.data.error !== "undefined" &&
            typeof e.response.data.error.collection !== "undefined"
          ) {
            this.errorDoc = e.response.data.error.collection;
          }
        }
       }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>